import { render, staticRenderFns } from "./ProductsFoundersContainer.vue?vue&type=template&id=d7cbab94&scoped=true&"
import script from "./ProductsFoundersContainer.vue?vue&type=script&lang=js&"
export * from "./ProductsFoundersContainer.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFoundersContainer.vue?vue&type=style&index=0&id=d7cbab94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cbab94",
  null
  
)

export default component.exports